<template>
  <div class="sign-up-success is-centered">
    <img
      :src="logo"
      alt="logo"
    >

    <h2 class="title is-4 has-text-white has-text-centered">
      ¡Verifica tu correo!
    </h2>

    <p class="content has-text-white has-text-centered">
      Te hemos enviado un link para activar tu cuenta.
      <br class="is-hidden-mobile">
      Es necesario que lo verifiques para iniciar sesión.
      <br>
      *Este link tiene una vigencia de 24 horas.
    </p>

    <button
      class="button is-uppercase is-primary"
      :class="{ 'is-loading': loading }"
      :disabled="loading"
      @click="resendActivationLink"
    >
      reenviar link de activación
    </button>

    <RouterLink
      class="has-text-white"
      :to="{ name: 'SignOut' }"
    >
      Iniciar sesión con otra cuenta
    </RouterLink>
  </div>
</template>

<script>
import merge from 'lodash/merge';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'VerificationPending',
  data() { return { loading: false }; },
  computed: mapState({ logo: ({ ui }) => ui.logoWhite }),
  methods: merge(
    mapActions({ resend: 'auth/resendEmailVerification' }),
    {
      async resendActivationLink() {
        if (this.loading) return false;

        this.loading = true;

        await this.resend();

        this.loading = false;

        return true;
      },
    },
  ),
};
</script>

<style scoped>
.sign-up-success {
  padding: 2rem;
}

.button {
  margin-bottom: 2rem;
}

a {
  text-decoration: underline;
}

@media screen and (min-width: 769px) {
  .sign-up-success {
    border-radius: 15px;
  }
}

img {
  width: 300px;
  height: auto;
  padding: 1rem 0;
}
</style>
